<template>
  <div class="page-container">
    <div class="search-panel">
      <el-form ref="searchForm" :inline="true" :model="search" size="mini">
        <el-form-item label="합산 단위">
          <el-select v-model="search.per" @change="resetSearchForm('due')">
            <el-option label="일" value="date" />
            <el-option label="월" value="month" />
            <el-option label="년" value="year" />
          </el-select>
        </el-form-item>
        <el-form-item label="검색 시작">
          <el-date-picker
            v-model="search.start"
            :type="search.per"
            placeholder="Pick a day">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="검색 기간">
          <el-select v-model="search.due">
            <el-option 
              v-for="item in searchDueOptions[search.per]" 
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchHandler">검색</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="5">
      <el-col :span="8" v-loading="!chart.joined_user.loaded">
        <div class="dashboard-chart">
          <highcharts v-if="chart.joined_user.loaded" :options="chart.joined_user.options"></highcharts>
        </div>
      </el-col>
      <el-col :span="8" v-loading="!chart.paid_user.loaded">
        <div class="dashboard-chart">
          <highcharts v-if="chart.paid_user.loaded" :options="chart.paid_user.options"></highcharts>
        </div>    
      </el-col>
      <el-col :span="8" v-loading="!chart.payment_summary.loaded">
        <div class="dashboard-chart">
          <highcharts v-if="chart.payment_summary.loaded" :options="chart.payment_summary.options"></highcharts>
        </div>    
      </el-col>
    </el-row>
    <div style="height: 5px"></div>
    <el-row :gutter="5" v-loading="!chart.remote_usage.loaded">
      <el-col :span="8">
        <div class="dashboard-chart">
          <highcharts v-if="chart.remote_usage.loaded" :options="chart.remote_usage.options"></highcharts>
        </div>    
      </el-col>
      <!-- 
      <el-col :span="8" v-loading="!chart.remote_usage.loaded">
        <div class="dashboard-chart">
          <highcharts v-if="chart.remote_usage.loaded" :options="chart.remote_avg.options"></highcharts>
        </div>    
      </el-col> 
      -->
      <el-col :span="8" v-loading="!chart.file_transfer.loaded">
        <div class="dashboard-chart">
          <highcharts v-if="chart.file_transfer.loaded" :options="chart.file_transfer.options"></highcharts>
        </div>    
      </el-col> 
      <el-col :span="8" v-loading="!chart.memo.loaded">
        <div class="dashboard-chart" v-if="chart.memo.loaded">
          <el-table :data="chart.memo.list" size="mini" :show-header="false">
            <el-table-column>
              <template slot-scope="scope">
                <router-link 
                  class="memo-preview"
                  :to="{
                    name: 'management-detail', 
                    params: {company_pk: scope.row.company_fk}
                  }">{{scope.row.memo}}
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  methods: {
    async getJoinedUser () {
      console.log('GET JOINED USER COUNT')
      let params = this.search
      let response = await this.$http.get('dashboard/joined_users', {params})
      let utcOffset = moment().utcOffset()
      let data = response.data.map(v => {
        return [ this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf(), v.user_count ]
      })

      this.chart.joined_user.options.series[0].data = data
      this.chart.joined_user.loaded = true

      return response
    },
    async getPaidUser () {
      console.log('GET PAID USER COUNT')
      let params = this.search
      let response = await this.$http.get('dashboard/paid_user', {params})
      let utcOffset = moment().utcOffset()
      let data = response.data.map(v => {
        return [ this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf(), v.user_count ]
      })

      this.chart.paid_user.options.series[0].data = data
      this.chart.paid_user.loaded = true

      return response
    },
    async getPaymentSummary () {
      console.log('GET PAYMENT SUMMARY')
      let params = this.search
      let response = await this.$http.get('dashboard/payment_summary', {params})
      let utcOffset = moment().utcOffset()
      // let data = response.data.map(v => {
      //   return [ this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf(), v.summary ]
      // })

      let data = response.data.map(v => {
        let key = this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf()
        return {
          'SC0010': [key , v['SC0010']],
          'SC0030': [key , v['SC0030']],
          'SC0060': [key , v['SC0060']],
          'CT0010': [key , v['CT0010']],
          'CT0020': [key , v['CT0020']],
          'CT0030': [key , v['CT0030']],
          'OTHER': [key , v['summary'] - (v['SC0010'] + v['SC0030'] + v['SC0060'] + v['CT0010'])],
          'SUMMARY': [key, v['summary']]
        }
      })

      this.chart.payment_summary.options.series[0].data = data.map(v => v['SC0010'])
      this.chart.payment_summary.options.series[1].data = data.map(v => v['CT0010'])
      this.chart.payment_summary.options.series[2].data = data.map(v => v['SC0030'])
      this.chart.payment_summary.options.series[3].data = data.map(v => v['SC0060'])
      // this.chart.payment_summary.options.series[4].data = data.map(v => v['CT0020'])
      // this.chart.payment_summary.options.series[5].data = data.map(v => v['CT0030'])
      this.chart.payment_summary.options.series[4].data = data.map(v => v['OTHER'])
      this.chart.payment_summary.options.series[5].data = data.map(v => v['SUMMARY'])
      this.chart.payment_summary.loaded = true

      return response
    },
    async getRemoteUsage () {
      console.log('GET REMOTE USAGE')
      let params = this.search
      let response = await this.$http.get('dashboard/remote_usage', {params})
      let utcOffset = moment().utcOffset()
      let data = response.data.map(v => {
        return [
          this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf(),
          v.duration
        ]
      })

      let avg_data = response.data.map(v => {
        return [
          this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf(),
          Math.round(v.duration / v.count)
        ]
      })

      this.chart.remote_usage.options.series[0].data = data
      this.chart.remote_avg.options.series[0].data = avg_data
      this.chart.remote_usage.loaded = true

      return response
    },
    async getFileTransfer () {
      console.log('GET FILE TRANSFER')
      let params = this.search
      let response = await this.$http.get('dashboard/file_transfer', {params})
      let utcOffset = moment().utcOffset()
      let data = response.data.map(v => {
        return [
          this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf(),
          Math.ceil(v.transfer_size / 1048576)
        ]
      })

      let max_data = response.data.map(v => {
        return [
          this.$service.moment(v.label, this.dateParseHelper.formatString).add(utcOffset, 'm').valueOf(),
          Math.ceil(v.transfer_max / 1048576)
        ]
      })

      this.chart.file_transfer.options.series[0].data = data
      this.chart.file_transfer.options.series[1].data = max_data
      this.chart.file_transfer.loaded = true

      return response
    },
    async getMemo () {
      let query = {
        order_by: [{ field: 'create_time', direction: 'desc' }]
      }
      let params = { results_per_page: 11, page: 1, q: JSON.stringify(query)  }
      let {data} = await this.$http.get('memo', {params})
      this.chart.memo.list = data.objects
      this.chart.memo.loaded = true
      return data
    },
    resetSearchForm (col) {
      if (!col) this.$refs.searchForm.reset()
      else this.search[col] = null
    },
    searchHandler () {
      if (this.search.due === null) return;
      let pivot = this.search.per === 'date' ? 'day' : this.search.per
      let date = this.$service.moment(this.search.start).startOf(pivot)
      this.search.start = date.format('YYYY-MM-DD HH:mm:ss')
      this.search.end = date.add(this.search.due, pivot).endOf(pivot).format('YYYY-MM-DD HH:mm:ss')
      console.log(this.search)

      this.getJoinedUser()
      this.getPaidUser()
      this.getPaymentSummary()
      this.getRemoteUsage()
      this.getFileTransfer()
    }
  },
  mounted() {
    this.getJoinedUser()
    this.getPaidUser()
    this.getPaymentSummary()
    this.getRemoteUsage()
    this.getFileTransfer()
    this.getMemo()
  },
  data () {
    return {
      search: {
        per: 'date',
        due: 10,
        start: this.$service.moment().add(-10, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: this.$service.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      },
      searchDueOptions: {
        year: [{label: '2년', value: 2}, {label: '3년', value: 3}],
        month: [
          {label: '6개월', value: 6},
          {label: '7개월', value: 7},
          {label: '8개월', value: 8},
          {label: '9개월', value: 9},
          {label: '10개월', value: 10},
          {label: '11개월', value: 11},
          {label: '12개월', value: 12}
        ],
        date: [
          {label: '10일', value: 10},
          {label: '11일', value: 11},
          {label: '12일', value: 12},
          {label: '13일', value: 13},
          {label: '14일', value: 14},
          {label: '15일', value: 15},
          {label: '16일', value: 16},
          {label: '17일', value: 17},
          {label: '18일', value: 18},
          {label: '19일', value: 19},
          {label: '20일', value: 20},
          {label: '21일', value: 21},
          {label: '22일', value: 22},
          {label: '23일', value: 23},
          {label: '24일', value: 24},
          {label: '25일', value: 25},
          {label: '26일', value: 26},
          {label: '27일', value: 27},
          {label: '28일', value: 28},
          {label: '29일', value: 29},
          {label: '30일', value: 30}
        ]
      },
      dateParseHelper: {
        formatString: 'YYYY-M-D'
      },
      chart: {
        file_transfer: {
          loaded: false,
          options: {
            title: { text: '파일전송 이용량 (MB)', style: {'font-size': '12px', 'color': '#a0a0a0'} },
            legend: { enabled: false },
            series: [
              {
                name: '전송량',
                type: 'line',
                data: [],
                maxPointWidth: 5,
                dataLabels: { enabled: true }
              },
              {
                name: '단일 최대 파일',
                type: 'line',
                data: [],
                maxPointWidth: 5,
                dataLabels: { enabled: true }
              }
            ],
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                day: '%m/%d',
                week: '%m/%d',
                month: '%m \'%y',
                year: '%Y'
              }
            },
            yAxis: {
              title: { text: null }
            },
            colors: ['#adadad', '#ffcc00'],
            credits: { enabled: false }
          }
        },
        joined_user: {
          loaded: false,
          options: {
            title: { text: '신규 가입', style: {'font-size': '12px', 'color': '#a0a0a0'} },
            legend: { enabled: false },
            series: [{
              name: '가입자(명)',
              type: 'column',
              data: [],
              maxPointWidth: 5,
              dataLabels: { enabled: false }
            }],
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                day: '%m/%d',
                week: '%m/%d',
                month: '%m \'%y',
                year: '%Y'
              }
            },
            yAxis: {
              title: { text: null }
            },
            colors: ['#a6e260'],
            credits: { enabled: false }
          }
        },
        paid_user: {
          loaded: false,
          options: {
            title: { text: '최초 결제 고객', style: {'font-size': '12px', 'color': '#a0a0a0'} },
            legend: { enabled: false },
            series: [{
              name: '결제고객(명)',
              type: 'column',
              data: [],
              maxPointWidth: 5,
              dataLabels: { enabled: false }
            }],
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                day: '%m/%d',
                week: '%m/%d',
                month: '%m \'%y',
                year: '%Y'
              }
            },
            yAxis: {
              title: { text: null }
            },
            colors: ['#2196f3'],
            credits: { enabled: false }
          }
        },
        payment_summary: {
          loaded: false,
          options: {
            title: { text: '결제량', style: {'font-size': '12px', 'color': '#a0a0a0'} },
            legend: { enabled: true },
            plotOptions: {
              column: { stacking: 'normal' }
            },
            series: [
              {
                name: '신용카드',
                type: 'column',
                data: [],
                maxPointWidth: 15,
                stack: 1
              },
              {
                name: '무통장입금',
                type: 'column',
                data: [],
                maxPointWidth: 15,
                stack: 1
              },
              {
                name: '계좌이체',
                type: 'column',
                data: [],
                maxPointWidth: 15,
                stack: 1
              },
              {
                name: '핸드폰결제',
                type: 'column',
                data: [],
                maxPointWidth: 15,
                stack: 1
              },
              // {
              //   name: '무상제공',
              //   type: 'column',
              //   data: [],
              //   maxPointWidth: 15,
              //   stack: 1
              // },
              // {
              //   name: '최고관리자',
              //   type: 'column',
              //   data: [],
              //   maxPointWidth: 15,
              //   stack: 1
              // },
              {
                name: '기타',
                type: 'column',
                data: [],
                maxPointWidth: 15,
                stack: 1
              },
              {
                name: '총 결제',
                type: 'line',
                data: [],
                maxPointWidth: 1,
                dataLabels: { enabled: true }
              }
            ],
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                day: '%m/%d',
                week: '%m/%d',
                month: '%m \'%y',
                year: '%Y'
              }
            },
            yAxis: {
              title: { text: null }
            },
            colors: ['#e64949', '#ffcc00', '#66caa3', '#0fa5b1', '#a0a0a0', '#00000005'],
            credits: { enabled: false }
          }
        },
        remote_usage: {
          loaded: false,
          options: {
            title: { text: '원격제어 사용량 합산', style: {'font-size': '12px', 'color': '#a0a0a0'} },
            legend: { enabled: false },
            series: [{
              name: '사용시간',
              type: 'line',
              data: [],
              maxPointWidth: 5,
              dataLabels: { enabled: true }
            }],
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                day: '%m/%d',
                week: '%m/%d',
                month: '%m \'%y',
                year: '%Y'
              }
            },
            yAxis: {
              title: { text: null }
            },
            colors: ['#adadad'],
            credits: { enabled: false }
          }
        },
        remote_avg: {
          loaded: false,
          options: {
            title: { text: '원격제어 사용량 평균', style: {'font-size': '12px', 'color': '#a0a0a0'} },
            legend: { enabled: false },
            series: [{
              name: '평균사용시간',
              type: 'line',
              data: [],
              maxPointWidth: 5,
              dataLabels: { enabled: true }
            }],
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                day: '%m/%d',
                week: '%m/%d',
                month: '%m \'%y',
                year: '%Y'
              }
            },
            yAxis: {
              title: { text: null }
            },
            colors: ['#adadad'],
            credits: { enabled: false }
          }
        },
        memo: {
          loaded: false,
          list: []
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-chart {
  // padding: 5px;
  min-height: 400px;
}
.memo-preview {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #888;
  text-decoration: none;
  &:hover { color: black; }
}
</style>


